module.exports = __webpack_public_path__ + "img/infrastructure-21.8082a27f.png";